import { Anchor, Text } from '@mantine/core';
import dayjs from 'dayjs';
import i18next, { t } from 'i18next';
import { PrescriptionPackage } from 'models/prescription';
import { CurrentUserData, PatientData } from 'models/user';
import { PatientProfile } from 'utils/models';
import { displayNotificationSuccess } from './notifications';
import { showFullName } from './helpers';

export const PRESCRIPTION_REASONS = [
  'new_complaints',
  'patient_request',
  'high_risk',
  'lasting_complaints',
  'post_cardioversion',
  'post_ablation',
  'post_cryptogenic_stroke',
  'heart_failure',
  'other',
];

export const PRESCRIPTION_REASONS_USA = ['diagnosed_with_af', 'susceptible_to_af'];

const DAY_MILLISECONDS = 86400000;
export const calculateDurationInDays = (duration: number) => {
  return duration / DAY_MILLISECONDS;
};

export const showDownloadNotification = (notificationId: string, downloadUrl: string, fileName: string) => {
  displayNotificationSuccess({
    notificationId,
    autoClose: 10000,
    message: (
      <>
        {i18next.t('prescript_created_notification')}
        <Anchor c={'var(--mantine-color-blue-5)'} mt={'md'} href={downloadUrl} download={`${fileName}.pdf`}>
          <Text fw={'bold'}>{i18next.t('download_label')}</Text>
        </Anchor>
      </>
    ),
  });
};

export const toPrescriptionPatient = (patientData: PatientData): PatientProfile => ({
  id: patientData.id ?? '',
  firstName: patientData.firstName ?? '',
  lastName: patientData.lastName ?? '',
  groups: patientData.visibleEnlistments.map((enlistment) => {
    const daysLeft = dayjs(enlistment.expiryTimestamp).diff(dayjs(), 'day', true);
    return {
      id: enlistment.groupId,
      expired: enlistment.expired,
      daysLeft: daysLeft > 0 ? daysLeft : 0,
      endDate: dayjs(enlistment.expiryTimestamp).valueOf(),
    };
  }),
});

export const buildEmailBody = (values: {
  prescriptionPackage?: PrescriptionPackage;
  patientData?: PatientData;
  userData?: CurrentUserData;
  language: string;
}) => {
  const { prescriptionPackage, patientData, userData, language } = values;
  return t('prescription_mail_body', {
    durationInDays: prescriptionPackage ? calculateDurationInDays(prescriptionPackage.duration) : 90,
    patientFirstName: patientData?.firstName || '',
    physicianName: showFullName(userData?.user),
    lng: language,
  });
};
